import React, { forwardRef } from 'react';
import { Button, ButtonProps } from '@mui/material';

export interface BannerButtonProps extends ButtonProps {}

/**
 * BannerButton is a proxy component to <Button variant="outlined" color="secondary" size="small" />
 */
export const BannerButton: React.FC<BannerButtonProps> = forwardRef((props, ref) => {
  return <Button ref={ref} variant="outlined" color="secondary" size="small" {...props} />;
});
